module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 165.96acdef3.png";